import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { find, each } from 'lodash';

@Component({
  selector: 'gen-checkboxlistIcon-input',
  templateUrl: './checkboxlistIcon-input.component.html',
  styleUrls: ['checkboxlistIcon-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CheckboxlistIconInputComponent implements OnInit {
  @Input() filter;


  ngOnInit() {
    if (this.filter.statistics) {
    this.filter.config.values = this.filter.statistics.values;
    }
    this.checkBoxSelect(this.filter);
  }

  checkBoxSelect(filterSelected) {
    this.filter.tooltip = filterSelected.selectedValue;
  }

  updateSelection(event, id) {
    const checkbox = event.target;
    const action = (checkbox.checked ? 'add' : 'remove');
    this.updateSelected(action, id);
  }

  getIconClass = (val: string) => {
    if (val === 'Germline') {
      return 'icon__TN-germline';
    }
     if (val === 'LOH') {
      return 'icon__TN-low';
    }
     if (val !== 'LOH' && val !== 'Germline' && val !== 'Somatic') {
      return 'icon__TN-unknown';
    }
  }

  updateSelected(action, id) {
    const isExists = find(this.filter.selectedValue.value, (val) => {
      return val.id === id;
    });
    const normalizedIdValue = id !== undefined ? id : null;
    if (action === 'add' && !isExists) {
      this.filter.selectedValue.value.push({ id: normalizedIdValue});
    }

    if (action === 'remove' && isExists) {
      let index: any = -1;
      each(this.filter.selectedValue.value, (data, idx) => {
        if (data.id === normalizedIdValue) {
          index = idx;
          return;
        }
      });
      if (index > -1) {
        this.filter.selectedValue.value.splice(index, 1);
      }
    }
  }


}
